import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  CATALOG_PRODUCTS,
  getProductDescription,
  PAGE_CONTENT_CLASS,
} from "../data/products";
import { toProductSlug } from "../seo/constants";

const ProductScrollItem = ({ product, index }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.35, rootMargin: "-8% 0px -8% 0px" },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id={toProductSlug(product.name)}
      ref={ref}
      className="flex items-center py-10 border-b border-[rgba(200,146,42,0.12)] last:border-b-0 scroll-mt-28"
    >
      <div
        className={`${PAGE_CONTENT_CLASS} w-full transition-all duration-1000 ease-out ${
          isVisible
            ? "translate-x-0 opacity-100"
            : "-translate-x-24 md:-translate-x-32 opacity-0"
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative rounded-lg border border-[rgba(200,146,42,0.2)] bg-[#111] p-2">
            <img
              src={product.image}
              alt={product.alt}
              className="block w-full h-auto max-w-full"
              loading={index < 2 ? "eager" : "lazy"}
            />
            <div className="absolute inset-0 pointer-events-none rounded-lg bg-gradient-to-t from-[#0D0D0D]/40 via-transparent to-transparent" />
            <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.2em] text-[#C8922A] bg-[rgba(0,0,0,0.7)] px-3 py-1 border border-[rgba(200,146,42,0.3)]">
              {product.category}
            </span>
          </div>

          <div className="space-y-4">
            <p className="text-[#C8922A] text-sm uppercase tracking-[0.25em]">
              {String(index + 1).padStart(2, "0")} /{" "}
              {String(CATALOG_PRODUCTS.length).padStart(2, "0")}
            </p>
            <h2 className="font-heading font-bold text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
              {product.name}
            </h2>
            <div className="h-[2px] w-16 bg-[#C8922A]" />
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
              {getProductDescription(product)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const ProductsPage = () => {
  return (
    <div className="min-h-screen bg-[#1a0f08]">
      <Header />
      <main id="main-content" className="pt-24 pb-16 bg-[#0D0D0D] min-h-screen">
        <div className={PAGE_CONTENT_CLASS}>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#d4a574] hover:text-[#c9923f] transition-colors mb-8 text-sm uppercase tracking-wider"
          >
            <ArrowLeft size={18} />
            Back to Home
          </Link>

          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Our Products
          </h1>
          {/* <p className="text-gray-300 text-lg leading-relaxed max-w-3xl mb-10">
            Full catalog from{" "}
            <strong className="text-white">
              Rahul Engineering Works Kanpur
            </strong>
            : industrial bakery ovens, dough mixers, bread &amp; rusk slicers,
            conveyors and automatic lines. Manufacturer of bakery machines in
            Kanpur, Uttar Pradesh — supplying pan-India since 1992.
          </p>
          <div className="h-[2px] w-12 bg-[#C8922A] mb-12" /> */}
        </div>

        {CATALOG_PRODUCTS.map((product, index) => (
          <ProductScrollItem key={product.id} product={product} index={index} />
        ))}
      </main>
      <Footer />
    </div>
  );
};

export default ProductsPage;
